import type { ASTNode } from './ast'

export const extractMids = (tree: ASTNode, data: string[] = []) => {
  if (tree.left) {
    extractMids(tree.left, data)
  }

  if (tree.right) {
    extractMids(tree.right, data)
  }

  if (tree.type === 'BinaryExpression') {
    if (tree.operator === '=') {
      if (tree?.left?.value === 'Mid') {
        if (tree?.right?.value) {
          data.push(tree.right.value)
        }
      }
    }
  }

  return data
}

export const extractMccs = (tree: ASTNode, data: string[] = []) => {
  if (tree.left) {
    extractMccs(tree.left, data)
  }

  if (tree.right) {
    extractMccs(tree.right, data)
  }

  if (tree.type === 'BinaryExpression') {
    if (tree.operator === '=') {
      if (tree?.left?.value === 'Mcc') {
        if (tree?.right?.value) {
          data.push(tree.right.value)
        }
      }
    }
  }

  return data
}
